import "../stylesheet/Footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <small className="footer__small">@anafruiz</small>
      <small className="footer__small">© 2021</small>
    </div>
  );
};
export default Footer;
